(function () {
  const KEY = 'localWishlist';

  function getWishlist() {
    try {
      const data = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(data) {
    localStorage.setItem(KEY, JSON.stringify(data));
  }

  function clean(list) {
    return (list || []).filter(h =>
      h && h !== 'null' && h !== 'undefined'
    );
  }

  function updateUI() {
    const wishlist = clean(getWishlist());

    // ❤️ Active state on all wishlist buttons
    document.querySelectorAll('.js-btn-wishlist').forEach(btn => {
      const handle = btn.dataset.handle;
      if (!handle) return;
      const isActive = wishlist.includes(handle);
      btn.classList.toggle('active', isActive);
      btn.setAttribute('aria-pressed', isActive);
      btn.title = isActive ? 'Remove from Wishlist' : 'Add to Wishlist';
    });

    // 🔢 Header count badges
    document.querySelectorAll('.js-wishlist-count').forEach(el => {
      el.textContent = wishlist.length;
    });
  }

  // ❤️ ADD / REMOVE TOGGLE
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.js-btn-wishlist');
    if (!btn) return;
    e.preventDefault();

    const handle = btn.dataset.handle;
    if (!handle || handle === 'null' || handle === 'undefined') return;

    let wishlist = clean(getWishlist());
    const index = wishlist.indexOf(handle);

    if (index !== -1) {
      wishlist.splice(index, 1);
    } else {
      wishlist.push(handle);
    }

    setWishlist(wishlist);
    updateUI();

    // 🔔 Custom event — wishlist page bhi sun sakta hai
    window.dispatchEvent(new CustomEvent('wishlist:updated', {
      detail: { wishlist }
    }));
  });

  // 🔄 Auto sync
  document.addEventListener('DOMContentLoaded', updateUI);
  window.addEventListener('pageshow', updateUI);
  window.addEventListener('storage', updateUI); // tab sync
})();